// Auto-ported from bijoy_converter.py (backend). Converts Unicode Bengali ->
// Bijoy/SutonnyMJ ANSI bytes so the editor preview matches the printed card.

const MAIN_CHAR = [
  ["\u0964", "|"],
  ["\u2018", "\u00d4"],
  ["\u2019", "\u00d5"],
  ["\u201c", "\u00d2"],
  ["\u201d", "\u00d3"],
  ["\u09cd\u09b0\u09cd\u09af", "\u00aa\u00a8"],
  ["\u09ae\u09cd\u09aa\u09cd\u09b0", "\u00a4c\u00d6"],
  ["\u09b0\u200c\u09cd\u09af", "i\u00a8"],
  ["\u0995\u09cd\u09b7\u09cd\u09ae", "\u00b2"],
  ["\u0995\u09cd\u0995", "\u00b0"],
  ["\u0995\u09cd\u099f", "\u00b1"],
  ["\u0995\u09cd\u09a4", "\u00b3"],
  ["\u0995\u09cd\u09ac", "K\u00a1"],
  ["\u09b8\u09cd\u0995\u09cd\u09b0", "\u00af\u0152"],
  ["\u0995\u09cd\u09b0", "\u00b5"],
  ["\u0995\u09cd\u09b2", "K\u00ac"],
  ["\u0995\u09cd\u09b7", "\u00b6"],
  ["\u0995\u09cd\u09b8", "\u00b7"],
  ["\u0997\u09c1", "\u00b8"],
  ["\u0997\u09cd\u09a7", "\u00bb"],
  ["\u0997\u09cd\u09a8", "M\u0153"],
  ["\u0997\u09cd\u09ae", "M\u00a5"],
  ["\u0997\u09cd\u09b2", "M\u00ad"],
  ["\u0997\u09cd\u09b0\u09c1", "M\u00aay"],
  ["\u0999\u09cd\u0995", "\u00bc"],
  ["\u0999\u09cd\u0995\u09cd\u09b7", "\u2022\u00b6"],
  ["\u0999\u09cd\u0996", "\u2022L"],
  ["\u0999\u09cd\u0997", "\u00bd"],
  ["\u0999\u09cd\u0998", "\u2022N"],
  ["\u099a\u09cd\u099b\u09cd\u09ac", "\u201dQ\u00a1"],
  ["\u099a\u09cd\u099a", "\u201dP"],
  ["\u099a\u09cd\u099b", "\u201dQ"],
  ["\u099a\u09cd\u099e", "\u201dT"],
  ["\u099c\u09cd\u099c\u09cd\u09ac", "\u00be\u00a1"],
  ["\u099c\u09cd\u099c", "\u00be"],
  ["\u099c\u09cd\u099d", "\u00c0"],
  ["\u099c\u09cd\u099e", "\u00c1"],
  ["\u099c\u09cd\u09ac", "R\u00a1"],
  ["\u099e\u09cd\u099a", "\u00c2"],
  ["\u099e\u09cd\u099b", "\u00c3"],
  ["\u099e\u09cd\u099c", "\u00c4"],
  ["\u099e\u09cd\u099d", "\u00c5"],
  ["\u099f\u09cd\u099f", "\u00c6"],
  ["\u099f\u09cd\u09ac", "U\u00a1"],
  ["\u099f\u09cd\u09ae", "U\u00a5"],
  ["\u09a1\u09cd\u09a1", "\u00c7"],
  ["\u09a3\u09cd\u099f", "\u00c8"],
  ["\u09a3\u09cd\u09a0", "\u00c9"],
  ["\u09a8\u09cd\u09b8", "\u00dd"],
  ["\u09a3\u09cd\u09a1", "\u00ca"],
  ["\u09a8\u09cd\u09a4\u09c1", "\u0161\u2018"],
  ["\u09a3\u09cd\u09ac", "Y^"],
  ["\u09a4\u09cd\u09a4\u09cd\u09ac", "\u00cb\u00a1"],
  ["\u09a4\u09cd\u09a4", "\u00cb"],
  ["\u09a4\u09cd\u09a5", "\u00cc"],
  ["\u09a4\u09cd\u09a8", "Z\u0153"],
  ["\u09a4\u09cd\u09ae", "Z\u00a5"],
  ["\u09a8\u09cd\u09a4\u09cd\u09ac", "\u0161\u2014\u00a1"],
  ["\u09a4\u09cd\u09ac", "Z\u00a1"],
  ["\u09a5\u09cd\u09ac", "_\u00a1"],
  ["\u09a6\u09cd\u0997", "\u02dcM"],
  ["\u09a6\u09cd\u0998", "\u02dcN"],
  ["\u09a6\u09cd\u09a6", "\u00cf"],
  ["\u09a6\u09cd\u09a7", "\u00d7"],
  ["\u09a6\u09cd\u09ac", "\u02dc\u00a1"],
  ["\u09a6\u09cd\u09ad", "\u2122\u00a2"],
  ["\u09a6\u09cd\u09ae", "\u00d9"],
  ["\u09a6\u09cd\u09b0\u09c1", "`\u00aay"],
  ["\u09a7\u09cd\u09ac", "a\u0178"],
  ["\u09a7\u09cd\u09ae", "a\u00a5"],
  ["\u09a8\u09cd\u099f", "\u203aU"],
  ["\u09a8\u09cd\u09a0", "\u00da"],
  ["\u09a8\u09cd\u09a1", "\u00db"],
  ["\u09a8\u09cd\u09a4\u09cd\u09b0", "\u0161\u00bf"],
  ["\u09a8\u09cd\u09a4", "\u0161\u2014"],
  ["\u09b8\u09cd\u09a4\u09cd\u09b0", "\u00af\u00bf"],
  ["\u09a4\u09cd\u09b0", "\u00ce"],
  ["\u09a8\u09cd\u09a5", "\u0161\u2019"],
  ["\u09a8\u09cd\u09a6", "\u203a`"],
  ["\u09a8\u09cd\u09a6\u09cd\u09ac", "\u203a\u00d8"],
  ["\u09a8\u09cd\u09a7", "\u00dc"],
  ["\u09a8\u09cd\u09a8", "b\u0153"],
  ["\u09a8\u09cd\u09ac", "\u0161^"],
  ["\u09a8\u09cd\u09ae", "b\u00a5"],
  ["\u09aa\u09cd\u099f", "\u00de"],
  ["\u09aa\u09cd\u09a4", "\u00df"],
  ["\u09aa\u09cd\u09a8", "c\u0153"],
  ["\u09aa\u09cd\u09aa", "\u00e0"],
  ["\u09aa\u09cd\u09b2", "c\u00ad"],
  ["\u09aa\u09cd\u09b8", "\u00e1"],
  ["\u09ab\u09cd\u09b2", "d\u00ac"],
  ["\u09ac\u09cd\u099c", "\u00e2"],
  ["\u09ac\u09cd\u09a6", "\u00e3"],
  ["\u09ac\u09cd\u09a7", "\u00e4"],
  ["\u09ac\u09cd\u09ac", "e\u0178"],
  ["\u09ac\u09cd\u09b2", "e\u00ad"],
  ["\u09ad\u09cd\u09b0", "\u00e5"],
  ["\u09ae\u09cd\u09a8", "g\u0153"],
  ["\u09ae\u09cd\u09aa", "\u00a4\u00fa"],
  ["\u09ae\u09cd\u09ab", "\u00e7"],
  ["\u09ae\u09cd\u09ac", "\u00a4^"],
  ["\u09ae\u09cd\u09ad", "\u00a4\u00a2"],
  ["\u09ae\u09cd\u09ad\u09cd\u09b0", "\u00a4\u00a3"],
  ["\u09ae\u09cd\u09ae", "\u00a4\u00a7"],
  ["\u09ae\u09cd\u09b2", "\u00a4\u00ad"],
  ["\u09cd\u09b0", "\u00aa"],
  ["\u09b0\u09c1", "iy"],
  ["\u09b0\u09c2", "i\u0192"],
  ["\u09b2\u09cd\u0995", "\u00e9"],
  ["\u09b2\u09cd\u0997", "\u00ea"],
  ["\u09b2\u09cd\u099f", "\u00eb"],
  ["\u09b2\u09cd\u09a1", "\u00ec"],
  ["\u09b2\u09cd\u09aa", "\u00ed"],
  ["\u09b2\u09cd\u09ab", "\u00ee"],
  ["\u09b2\u09cd\u09ac", "j\u00a6"],
  ["\u09b2\u09cd\u09ae", "j\u00a5"],
  ["\u09b2\u09cd\u09b2", "j\u00ad"],
  ["\u09b6\u09c1", "\u00ef"],
  ["\u09b6\u09cd\u099a", "\u00f0"],
  ["\u09b6\u09cd\u09a8", "k\u0153"],
  ["\u09b6\u09cd\u09ac", "k\u00a6"],
  ["\u09b6\u09cd\u09ae", "k\u00a5"],
  ["\u09b6\u09cd\u09b2", "k\u00ad"],
  ["\u09b7\u09cd\u0995", "\u00ae\u2039"],
  ["\u09b7\u09cd\u0995\u09cd\u09b0", "\u00ae\u0152"],
  ["\u09b7\u09cd\u099f", "\u00f3"],
  ["\u09b7\u09cd\u09a0", "\u00f4"],
  ["\u09b7\u09cd\u09a3", "\u00f2"],
  ["\u09b7\u09cd\u09aa", "\u00ae\u00fa"],
  ["\u09b7\u09cd\u09ab", "\u00f5"],
  ["\u09b7\u09cd\u09ae", "\u00ae\u00a7"],
  ["\u09b8\u09cd\u0995", "\u00af\u2039"],
  ["\u09b8\u09cd\u099f", "\u00f7"],
  ["\u09b8\u09cd\u0996", "\u00f6"],
  ["\u09b8\u09cd\u09a4", "\u00af\u2014"],
  ["\u09b8\u09cd\u09a4\u09c1", "\u00af\u2018"],
  ["\u09b8\u09cd\u09a5", "\u00af\u2019"],
  ["\u09b8\u09cd\u09a8", "m\u0153"],
  ["\u09b8\u09cd\u09aa", "\u00af\u00fa"],
  ["\u09b8\u09cd\u09ab", "\u00f9"],
  ["\u09b8\u09cd\u09ac", "\u00af^"],
  ["\u09b8\u09cd\u09ae", "\u00af\u00a7"],
  ["\u09b8\u09cd\u09b2", "\u00af\u00ad"],
  ["\u09b9\u09c1", "\u00fb"],
  ["\u09b9\u09cd\u09a3", "n\u00e8"],
  ["\u09b9\u09cd\u09ac", "n\u0178"],
  ["\u09b9\u09cd\u09a8", "\u00fd"],
  ["\u09b9\u09cd\u09ae", "\u00fe"],
  ["\u09b9\u09cd\u09b2", "n\u00ac"],
  ["\u09b9\u09c3", "\u00fc"],
  ["\u09b0\u09cd", "\u00a9"],
  ["\u09cd\u09af", "\u00a8"],
  ["\u09cd", "&"],
  ["\u0986", "Av"],
  ["\u0985", "A"],
  ["\u0987", "B"],
  ["\u0988", "C"],
  ["\u0989", "D"],
  ["\u098a", "E"],
  ["\u098b", "F"],
  ["\u098f", "G"],
  ["\u0990", "H"],
  ["\u0993", "I"],
  ["\u0994", "J"],
  ["\u0995", "K"],
  ["\u0996", "L"],
  ["\u0997", "M"],
  ["\u0998", "N"],
  ["\u0999", "O"],
  ["\u099a", "P"],
  ["\u099b", "Q"],
  ["\u099c", "R"],
  ["\u099d", "S"],
  ["\u099e", "T"],
  ["\u099f", "U"],
  ["\u09a0", "V"],
  ["\u09a1", "W"],
  ["\u09a2", "X"],
  ["\u09a3", "Y"],
  ["\u09a4", "Z"],
  ["\u09a5", "_"],
  ["\u09a6", "`"],
  ["\u09a7", "a"],
  ["\u09a8", "b"],
  ["\u09aa", "c"],
  ["\u09ab", "d"],
  ["\u09ac", "e"],
  ["\u09ad", "f"],
  ["\u09ae", "g"],
  ["\u09af", "h"],
  ["\u09b0", "i"],
  ["\u09b2", "j"],
  ["\u09b6", "k"],
  ["\u09b7", "l"],
  ["\u09b8", "m"],
  ["\u09b9", "n"],
  ["\u09dd", "o"],
  ["\u09de", "p"],
  ["\u09df", "q"],
  ["\u09ce", "r"],
  ["\u09e6", "0"],
  ["\u09e7", "1"],
  ["\u09e8", "2"],
  ["\u09e9", "3"],
  ["\u09ea", "4"],
  ["\u09eb", "5"],
  ["\u09ec", "6"],
  ["\u09ed", "7"],
  ["\u09ee", "8"],
  ["\u09ef", "9"],
  ["\u09be", "v"],
  ["\u09bf", "w"],
  ["\u09c0", "x"],
  ["\u09c1", "y"],
  ["\u09c2", "~"],
  ["\u09c3", "\u2026"],
  ["\u09c7", "\u2021"],
  ["\u09c8", "\u2030"],
  ["\u09d7", "\u0160"],
  ["\u0982", "s"],
  ["\u0983", "t"],
  ["\u0981", "u"],
];
const CONSONANTS = new Set(["\u0981", "\u0982", "\u0983", "\u0995", "\u0996", "\u0997", "\u0998", "\u0999", "\u099a", "\u099b", "\u099c", "\u099d", "\u099e", "\u099f", "\u09a0", "\u09a1", "\u09a2", "\u09a3", "\u09a4", "\u09a5", "\u09a6", "\u09a7", "\u09a8", "\u09aa", "\u09ab", "\u09ac", "\u09ad", "\u09ae", "\u09af", "\u09b0", "\u09b2", "\u09b6", "\u09b7", "\u09b8", "\u09b9", "\u09ce", "\u09dd", "\u09de", "\u09df", ]);
const HALANT = "\u09cd";
const RA = "\u09b0";
const PRE_KARS = ["\u09bf", "\u09c8", "\u09c7"];
const charAt = (s, i) => (i >= 0 && i < s.length ? s[i] : "");
const isConsonant = (c) => CONSONANTS.has(c);
const isHalant = (c) => c === HALANT;
const isPreKar = (c) => PRE_KARS.includes(c);
function canonNukta(s){return s.split("\u09a1\u09bc").join("\u09dd").split("\u09a2\u09bc").join("\u09de").split("\u09af\u09bc").join("\u09df");}
function splitOkar(s){return s.split("\u09cb").join("\u09c7\u09be").split("\u09cc").join("\u09c7\u09d7");}
function reorderForAscii(s){
  let cy=0,i=0;
  while(i<s.length){
    const ch=charAt(s,i);
    if(isPreKar(ch)){
      let j=1;
      while(isConsonant(charAt(s,i-j))){ if(i-j<0||i-j<=cy)break; if(isHalant(charAt(s,i-j-1)))j+=2; else break; }
      s=s.slice(0,i-j)+charAt(s,i)+s.slice(i-j,i)+s.slice(i+1); cy=i+1; i=cy; continue;
    }
    if(isHalant(ch)&&charAt(s,i-1)===RA&&!isHalant(charAt(s,i-2))){
      let j=1,az=0;
      while(true){
        if(isConsonant(charAt(s,i+j))&&isHalant(charAt(s,i+j+1)))j+=2;
        else if(isConsonant(charAt(s,i+j))&&isPreKar(charAt(s,i+j+1))){az=1;break;}
        else break;
      }
      s=s.slice(0,i-1)+s.slice(i+j+1,i+j+az+1)+s.slice(i+1,i+j+1)+charAt(s,i-1)+charAt(s,i)+s.slice(i+j+az+1);
      i+=(j+az); cy=i+1; continue;
    }
    i+=1;
  }
  return s;
}
function applyMap(s){ for(const [k,v] of MAIN_CHAR){ if(s.indexOf(k)!==-1) s=s.split(k).join(v);} return s; }
export function unicodeToBijoy(text){
  if(!text) return text;
  let s=text.normalize("NFC");
  s=canonNukta(s); s=splitOkar(s); s=reorderForAscii(s); s=applyMap(s);
  return s;
}
export const ANSI_BENGALI_FONTS = new Set(["sutonnymj","sutonny mj","sutonny","bijoy","bijoy bayanno","adarsha lipi","amar bangla","boishakhi","charukola","kalpana","modhumati","madhumati"]);
export function isAnsiBengaliFont(name){ return !!name && ANSI_BENGALI_FONTS.has(String(name).toLowerCase().trim()); }
